module.exports = __webpack_public_path__ + "media/images/powerpoint/mediametrie-background-8221f2e66f90be8a3e5a95079a494149.png";